// extracted by mini-css-extract-plugin
module.exports = {"resultsCount":"ResultsCount_resultsCount__4lN0r","leftToRight":"ResultsCount_leftToRight__AFswY"};